import { useCallback, useState } from 'react';
/**
 * A simple hook that allows you to quickly turn on/off for a flag.
 * Great for opening/closing a <Modal> or <Popover>.
 */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export default function useBooleanFlag(defaultValue = false) {
  const [flag, setFlag] = useState(Boolean(defaultValue));
  const setFlagTrue = useCallback(() => setFlag(true), []);
  const setFlagFalse = useCallback(() => setFlag(false), []);
  return [flag, setFlagTrue, setFlagFalse];
}